import styled, { keyframes } from "styled-components";
import {media} from "@/styles/Qtheme.ts";
import {TabletCalVW} from "@utils/CalVW.tsx";

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

const glow = keyframes`
  0%, 100% {
    box-shadow: 
      0 8px 32px rgba(0, 0, 0, 0.12),
      0 2px 8px rgba(0, 0, 0, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.1);
  }
  50% {
    box-shadow: 
      0 12px 40px rgba(248, 121, 67, 0.2),
      0 4px 12px rgba(255, 76, 0, 0.15),
      0 0 0 1px rgba(248, 121, 67, 0.15),
      inset 0 1px 0 rgba(255, 255, 255, 0.15);
  }
`;

const floatAnimation = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-5px);
  }
`;

const pulseGradient = keyframes`
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
`;

export const AssetSpotSection = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    width: 1200px;
    animation: ${fadeInUp} 0.8s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;

    /* &::before {
        content: '';
        position: absolute;
        top: -20px;
        left: 50%;
        transform: translateX(-50%);
        width: 80px;
        height: 4px;
        background: linear-gradient(
            90deg,
            #F87943 0%,
            #FF4C00 50%,
            #F87943 100%
        );
        border-radius: 2px;
        opacity: 0.8;
        animation: ${shimmer} 2s ease-in-out infinite;
        box-shadow: 0 2px 8px rgba(248, 121, 67, 0.4);
    } */

    @media ${media.desktop} {
        width: ${TabletCalVW(900)};
    }

    @media ${media.mobile} {
        &::before {
            width: 60px;
            height: 3px;
            top: -15px;
        }
    }
`;

export const AssetSpotContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 30px;
    margin-bottom: 200px;
    gap: 32px;
    position: relative;
    

    > * {
        animation: ${fadeInUp} 0.6s cubic-bezier(0.4, 0, 0.2, 1) forwards;
        
        &:nth-child(1) { animation-delay: 0.1s; }
        &:nth-child(2) { animation-delay: 0.2s; }
        &:nth-child(3) { animation-delay: 0.3s; }
        &:nth-child(4) { animation-delay: 0.4s; }
    }

    @media ${media.mobile} {
        gap: 24px;
        margin-bottom: 150px;
    }
`

export const AssetSpotHeaderSection = styled.div`
    width: 100%;
    padding: 40px;
    display: flex;
    flex-direction: column;
    background: ${({theme}) => theme.itemBg};
    border-radius: 20px;
    border: 1px solid ${({theme}) => theme.COLORS.border || 'rgba(255, 255, 255, 0.1)'};
    box-shadow: 
        0 8px 32px rgba(0, 0, 0, 0.12),
        0 2px 8px rgba(0, 0, 0, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(20px);
    position: relative;
    overflow: hidden;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
   

    &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 200%;
        height: 200%;
        background: radial-gradient(
            circle,
            rgba(248, 121, 67, 0.04) 0%,
            rgba(255, 76, 0, 0.02) 40%,
            transparent 70%
        );
        transform: translate(-50%, -50%);
        pointer-events: none;
        animation: ${floatAnimation} 6s ease-in-out infinite;
    }

    &:hover {
        transform: translateY(-4px) scale(1.01);
        box-shadow: 
            0 16px 48px rgba(248, 121, 67, 0.25),
            0 6px 16px rgba(255, 76, 0, 0.18),
            inset 0 1px 0 rgba(255, 255, 255, 0.25),
            0 0 0 1px rgba(248, 121, 67, 0.2),
            0 0 20px rgba(255, 76, 0, 0.1);
    }
    
    @media ${media.mobile} {
        padding: 28px 24px;
        border-radius: 16px;
        
        &:hover {
            transform: translateY(-2px) scale(1.005);
        }
    }
`

export const AssetSpotTableSection = styled.div`
    width: 100%;
    overflow-x: auto;
    background: ${({theme}) => theme.itemBg};
    border-radius: 18px;
    border: 1px solid ${({theme}) => theme.COLORS.border || 'rgba(255, 255, 255, 0.1)'};
    box-shadow: 
        0 6px 24px rgba(0, 0, 0, 0.11),
        0 2px 6px rgba(0, 0, 0, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(15px);
    position: relative;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;

    /* &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: linear-gradient(
            90deg,
            transparent 0%,
            #F87943 30%,
            #FF4C00 50%,
            #F87943 70%,
            transparent 100%
        );
        opacity: 0.4;
    } */

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: linear-gradient(
            90deg,
            transparent 0%,
            ${({theme}) => theme.COLORS.border || 'rgba(255, 255, 255, 0.2)'} 50%,
            transparent 100%
        );
        opacity: 0.3;
    }

    &:hover {
        transform: translateY(-3px) scale(1.005);
        box-shadow: 
            0 12px 40px rgba(248, 121, 67, 0.2),
            0 6px 12px rgba(255, 76, 0, 0.15),
            inset 0 1px 0 rgba(255, 255, 255, 0.18),
            0 0 0 1px rgba(248, 121, 67, 0.12),
            0 0 15px rgba(255, 76, 0, 0.08);
    }

    @media ${media.mobile} {
        border-radius: 14px;
        
        &:hover {
            transform: translateY(-2px) scale(1.002);
        }
    }
`

export const AssetSpotHistoryTableSection = styled.div`
    width: 100%;
    overflow-x: auto;
    background: ${({theme}) => theme.itemBg};
    border-radius: 18px;
    border: 1px solid ${({theme}) => theme.COLORS.border || 'rgba(255, 255, 255, 0.1)'};
    box-shadow: 
        0 6px 24px rgba(0, 0, 0, 0.11),
        0 2px 6px rgba(0, 0, 0, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(15px);
    position: relative;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;

    /* &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: linear-gradient(
            90deg,
            transparent 0%,
            rgba(248, 121, 67, 0.8) 30%,
            rgba(255, 76, 0, 0.9) 50%,
            rgba(248, 121, 67, 0.8) 70%,
            transparent 100%
        );
        opacity: 0.4;
    } */

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: linear-gradient(
            90deg,
            transparent 0%,
            ${({theme}) => theme.COLORS.border || 'rgba(255, 255, 255, 0.2)'} 50%,
            transparent 100%
        );
        opacity: 0.3;
    }

    &:hover {
        transform: translateY(-3px) scale(1.005);
        box-shadow: 
            0 12px 40px rgba(248, 121, 67, 0.18),
            0 6px 12px rgba(255, 76, 0, 0.12),
            inset 0 1px 0 rgba(255, 255, 255, 0.18),
            0 0 0 1px rgba(248, 121, 67, 0.1),
            0 0 15px rgba(255, 76, 0, 0.06);
    }

    @media ${media.mobile} {
        border-radius: 14px;
        
        &:hover {
            transform: translateY(-2px) scale(1.002);
        }
    }
`